import { supabase } from "../supabaseClient";
import { decode } from "base64-arraybuffer";
import { errorTost, offlineToast } from "./Toast";
import { Network } from "@capacitor/network";

async function loginWithEmailPass(email, password) {
  console.log({ email, password });
  const { data, error } = await supabase.auth.signIn({
    email: email,
    password: password,
  });
  if (data) return data;
  else throw error;
}
async function checkIsEmailExist(type, id) {
  var query;
  if (type === "FOS") {
    query = await supabase.from("FOS").select("*").eq("fosDisplayId", id);
  } else {
    query = await supabase
      .from("CP")
      .select("*,CpContactPerson!left(email)")
      .eq("cpDisplayId", id);
  }
  const { data, error } = query;
  if (data) return data;
  else throw error;
}
// !!For forget Password
async function checkIsEmailExistFP(type, id) {
  var query;
  if (type === "FOS") {
    query = await supabase.from("FOS").select("*").eq("fosDisplayId", id);
  } else {
    query = await supabase
      .from("CP")
      .select("*,CpContactPerson!left(*)")
      .eq("cpDisplayId", id);
  }
  const { data, error } = query;
  if (data) return data;
  else throw error;
}
async function getSalesPerson(name) {
  const { data, error } = await supabase
    .from("Users")
    .select("userId,name")
    .ilike("name", `%${name}%`);
  if (data) return data;
  else throw error;
}
// CP.cpSourceId references Users.userId (the CP sourcing user). Resolves it to
// the name shown as "CP Sourcing" on the profile. Returns null when the CP has
// no sourcing user set, which is the case for CPs registered before the
// sourcing field existed.
async function getCpSourceName(cpSourceId) {
  if (!cpSourceId) return null;
  const { data, error } = await supabase
    .from("Users")
    .select("name")
    .eq("userId", cpSourceId)
    .maybeSingle();
  if (error) throw error;
  return data?.name ?? null;
}

const CP_SOURCING_ROLE_ID = "039dd8e5-1916-42bf-a85f-45b852699de4";
async function getCpSources() {
  const { data, error } = await supabase
    .from("Users")
    .select("userId,name")
    .eq("isCpSourcingUser", true)
    .eq("isActive", true)
    .or(`roleId.is.null,roleId.neq.${CP_SOURCING_ROLE_ID}`)
    .order("name", { ascending: true });
  if (data) return data;
  else throw error;
}
async function checkCPIsAprroved(id) {
  const { data, error } = await supabase
    .from("CpContactPerson")
    .select("*,cpId(*)")
    .eq("cpContactPersonId", id);
  if (data) return data;
  else throw error;
}
async function updateRecommentdationToFoSTable(cpId, fosId) {
  const { data, error } = await supabase
    .from("FOS")
    .update({ cpId: cpId, last_updated_at: Date.now() })
    .eq("fosId", fosId);
  if (data) return data;
  else throw error;
}
async function updatePasswordFlag(flag, type, id) {
  if (type === "CP") {
    const { data, error } = await supabase
      .from("CP")
      .update({ isPasswordUpdated: flag, last_updated_at: Date.now() })
      .eq("cpId", id);
    if (data) return data;
    else throw error;
  } else if (type === "FOS") {
    const { data, error } = await supabase
      .from("FOS")
      .update({ isPasswordUpdated: flag, last_updated_at: Date.now() })
      .eq("fosId", id);
    if (data) return data;
    else throw error;
  }
}
// async function signUpCP(cpDetails, personalDetail, bankDetails, cpType) {

//   const { user, error } = await supabase.auth.signUp({
//     email: personalDetail.email.toLowerCase(),
//     password: personalDetail.password
//   },
//     {
//       data: {
//         type: "CP",
//         isGSTApplicable: cpDetails.gstApplicable,
//         billingName: cpDetails.billingName.toUpperCase().replace(/\s\s+/g, ' '),
//         msmeType: cpDetails.msmeAvalaible,
//         msmeNumber: cpDetails.msmeNumber,
//         cpType: cpType,
//         bankAccountHolderName: bankDetails.holderName.toUpperCase().replace(/\s\s+/g, ' '),
//         bankAccountNumber: bankDetails.accountNumber,
//         bankIFSCCode: bankDetails.ifscCode,
//         bankBranchName: bankDetails.branchName,
//         name: personalDetail.personaName.toUpperCase().replace(/\s\s+/g, ' '),
//         contactNumber: personalDetail.phoneNumber,
//         isFlagged: cpDetails.isFlagged,
//         recommendedBySalesId: cpDetails.recomendation.value,
//         // isPasswordUpdated: null      // ! default null handled in supabase table
//       }
//     })
//   if (user) return user;
//   else throw error;
// }

async function signUpCP(
  cpDetails,
  personalDetail,
  bankDetails,
  cpType,
  reraEndDate,
  reraStartDate,
  agentType
) {
  console.log(cpDetails, "cp details");
  console.log(personalDetail, "persondetails");
  console.log(bankDetails, "bankdetails");
  console.log(cpType, "cptypeeeee");
  console.log("reraEndDate", reraEndDate);
  console.log("reraStartDate", reraStartDate);
  console.log("agentType", agentType);

  const { user, error } = await supabase.auth.signUp(
    {
      email: personalDetail.email.toLowerCase(),
      password: personalDetail.password,
    },
    {
      data: {
        type: "CP",
        isGSTApplicable: cpDetails.gstApplicable,
        billingName: cpDetails.billingName.toUpperCase().replace(/\s\s+/g, " "),
        msmeType: cpDetails.msmeAvalaible,
        msmeNumber: cpDetails.msmeNumber,
      cpType: cpDetails?.reraExtracted?.cpType || cpType,
       typeOfAgent: cpDetails?.reraExtracted?.typeOfAgent || agentType,
       reraStartDate: cpDetails?.reraExtracted?.startDate || reraStartDate,
      reraEndDate: cpDetails?.reraExtracted?.endDate || reraEndDate,
      gstBusinessName: cpDetails?.gstObject?.business_name || null,
      gstLegalName: cpDetails?.gstObject?.legal_name || null,
      proprietorship_name: cpDetails?.proprietorshipName || null,


        bankAccountHolderName: bankDetails.holderName
          .toUpperCase()
          .replace(/\s\s+/g, " "),
        bankAccountNumber: bankDetails.accountNumber,
        bankIFSCCode: bankDetails.ifscCode,
        bankBranchName: bankDetails.branchName,
        BankAccountNumberText: bankDetails.accountNumber != null ? String(bankDetails.accountNumber) : null,
        name: personalDetail.personaName.toUpperCase().replace(/\s\s+/g, " "),
        contactNumber: personalDetail.phoneNumber,
        isFlagged: cpDetails.isFlagged,
        recommendedBySalesId: null,
        cpSourceId: cpDetails.cpSource?.value ?? null,
        // isPasswordUpdated: null      // default handled in Supabase
      },
    }
  );
  console.log("user=========>", user);
  console.log("error=====>", error);
  if (user) return user;
  else throw error;
}


async function signUpStaticCP() {
  const { user, error } = await supabase.auth.signUp(
    {
      email: process.env.REACT_APP_STATIC_CP_SIGNUP_EMAIL,
      password: process.env.REACT_APP_STATIC_CP_SIGNUP_PASSWORD,
    },
    {
      data: {
        type: "CP",
        isGSTApplicable: false,
        billingName: "KAMAAL HAMIDULLAH KHAN",
        msmeType: "Not Applicable",
        msmeNumber: null,
        cpType: "Individual",
        bankAccountHolderName: "MR. KHAN KAMAAL HAMI",
        bankAccountNumber: 10069291451,
        bankIFSCCode: "IDFB0041433",
        bankBranchName: "Balewadi",
        name: "KAMAAL KHAN",
        contactNumber: 9082004094,
        isFlagged: true,
        recommendedBySalesId: null,
        // isPasswordUpdated: null      // ! default null handled in supabase table
      },
    }
  );
  if (user) return user;
  else throw error;
}

async function getCpId(id) {
  const { data, error } = await supabase
    .from("CpContactPerson")
    .select("cpId,cpContactPersonId")
    .eq("cpContactPersonId", id);
  if (data) return data;
  else throw error;
}

async function addKYCDoc(cpId, cpDetails, gstApplicable) {
  console.log({ cpDetails }, gstApplicable);
  var query;
  if (gstApplicable === true || gstApplicable === "true") {
    query = await supabase.from("KycDocuments").insert([
      {
        cpId: cpId,
        docType: "Rera",
        docNumber: cpDetails.reraNumber.toUpperCase().replace(/\s\s+/g, " "),
        docHolderName: cpDetails.reraObject.details[0].agent_name
          .toUpperCase()
          .replace(/\s\s+/g, " "),
        docUrl: cpDetails.docUrl,
        otherDetails: cpDetails.reraObject.details[0],
      },
      {
        cpId: cpId,
        docType: "PanCard",
        docNumber: cpDetails.panNumber.toUpperCase().replace(/\s\s+/g, " "),
        docHolderName: cpDetails.panObject.full_name
          .toUpperCase()
          .replace(/\s\s+/g, " "),
        docUrl: "",
        otherDetails: cpDetails.panObject,
      },
      {
        cpId: cpId,
        docType: "GST",
        docNumber: cpDetails.gstNumber.toUpperCase(),
        docHolderName: cpDetails.gstObject.business_name
          .toUpperCase()
          .replace(/\s\s+/g, " "),
        docUrl: "",
        otherDetails: cpDetails.gstObject,
      },
    ]);
  } else {
    query = await supabase.from("KycDocuments").insert([
      {
        cpId: cpId,
        docType: "Rera",
        docNumber: cpDetails?.reraNumber,
        docHolderName: cpDetails?.reraObject?.details[0].agent_name
          ?.toUpperCase()
          .replace(/\s\s+/g, " "),
        docUrl: cpDetails?.docUrl,
        otherDetails: cpDetails?.reraObject.details[0],
      },
      {
        cpId: cpId,
        docType: "PanCard",
        docNumber: cpDetails?.panNumber?.toUpperCase().replace(/\s\s+/g, " "),
        docHolderName: cpDetails?.panObject?.full_name
          ?.toUpperCase()
          .replace(/\s\s+/g, " "),
        docUrl: "",
        otherDetails: cpDetails?.panObject,
      },
    ]);
  }
  const { data, error } = query;
  if (data) return data;
  else throw error;
}

//FOS
async function checkFOSIsAprroved(id) {
  const { data, error } = await supabase
    .from("FOS")
    .select("*,cpId!left(*)")
    .eq("fosId", id);
  if (data) return data;
  else throw error;
}
async function signUpFos(personalDetail, bankDetails, cpId) {
  const { user, error } = await supabase.auth.signUp(
    {
      email: personalDetail.email.toLowerCase(),
      password: personalDetail.password,
    },
    {
      data: {
        type: "FOS",
        cpId: cpId,
        name: personalDetail.name.toUpperCase().replace(/\s\s+/g, " "),
        contactNumber: personalDetail.phoneNumber,
        bankAccountHolderName: bankDetails.holderName,
        bankAccountNumber: bankDetails.accountNumber,
        bankIFSCCode: bankDetails.ifscCode,
        bankBranchName: bankDetails.branchName,
        BankAccountNumberText: bankDetails.accountNumber != null ? String(bankDetails.accountNumber) : null,
        // isPasswordUpdated: null      // ! default null handled in supabase table
      },
    }
  );
  if (user) return user;
  else throw error;
}

async function addKYCDocFos(id, details) {
  const { data, error } = await supabase.from("KycDocuments").insert([
    {
      fosId: id,
      docType: "PanCard",
      docNumber: details.panNumber,
      docHolderName: details.panName.toUpperCase().replace(/\s\s+/g, " "),
      docUrl: "",
      otherDetails: details.panObject,
    },
    {
      fosId: id,
      docType: "AadharCard",
      docNumber: details.aadharNumber,
      docHolderName: details.aadharName,
      docUrl: "",
      otherDetails: details.aadharObject,
    },
  ]);
  if (data) return data;
  else throw error;
}

async function getCpBillingName(name) {
  const { data, error } = await supabase
    .from("CP")
    .select("cpId,billingName")
    .ilike("billingName", `%${name}%`)
    .eq("approvalStatus", "approved");
  // .eq('cpType', 'Entity')
  if (data) return data;
  else throw error;
}

// async function getUniquePanNumber(panNumber) {
//   console.log(panNumber);
//   const { data, error } = await supabase
//     .from('KycDocuments')
//     .select('*')
//     .eq('docType', 'PanCard')
//     .eq('docNumber', panNumber.toUpperCase())
//     .or('cpId.not.is.null,fosId.not.is.null')

//   if (data) return data;
//   else throw error;
// }
async function checkForUniqueDocs(docNumber) {
  const { data, error } = await supabase
    .from("KycDocuments")
    .select("*")
    .eq("docNumber", docNumber)
    .eq("docType", "PanCard");
  // .is('leadId', null);
  if (data) return data;
  else throw error;
}
//base64
async function uploadFileToDb(fileName, file) {
  const { data, error } = await supabase.storage
    .from("kycdocuments")
    .upload("CpDocuments/" + fileName, decode(file), {
      contentType: "application/pdf",
    });
  if (data) return data;
  else throw error;
}

//check for CpContactPerson exist email or not on entering email
async function checkCPExists(emailId) {
  console.log(emailId);
  const { data, error } = await supabase
    .from("CpContactPerson")
    .select("*")
    .match({ email: emailId.toLowerCase() });
  if (data) return data;
  else throw error;
}
async function checkPhoneExistsApi(phone) {
  const { data, error } = await supabase
    .from("CpContactPerson")
    .select("*")
    .eq("contactNumber", Number(phone)); // ✅ correct column + numeric conversion

  if (data) return data;
  else throw error;
}

//check for FOS exist email or not on entering email
async function checkFOSExists(emailId) {
  const { data, error } = await supabase
    .from("FOS")
    .select("*")
    .match({ email: emailId.toLowerCase() });
  if (data) return data;
  else throw error;
}
async function getCPUId(billingName) {
  const { data, error } = await supabase
    .from("CP")
    .select("cpDisplayId")
    .match({ billingName: billingName });
  if (data) return data;
  else throw error;
}
async function getFOSId(emailId) {
  const { data, error } = await supabase
    .from("FOS")
    .select("fosDisplayId")
    .match({ email: emailId.toLowerCase() });
  if (data) return data;
  else throw error;
}
//check for billingName exist in cp table or not
async function checkPanNumberExists(docNumber) {
  const { data, error } = await supabase
    .from("KycDocuments")
    .select("*")
    .eq("docNumber", docNumber)
    .eq("docType", "PanCard");
  // .is('cpId', null);
  // .from('CP')
  // .select('billingName').match({ billingName: billingName })
  // return []
  if (data) return data;
  else throw error;
}
//check if a RERA number is already registered against another CP
async function checkReraNumberExists(docNumber) {
  const { data, error } = await supabase
    .from("KycDocuments")
    .select("*")
    .eq("docNumber", docNumber)
    .eq("docType", "Rera");
  if (data) return data;
  else throw error;
}
//check if a GST number is already registered against another CP
async function checkGSTNumberExists(docNumber) {
  const { data, error } = await supabase
    .from("KycDocuments")
    .select("*")
    .eq("docNumber", docNumber)
    .eq("docType", "GST");
  if (data) return data;
  else throw error;
}
//check if this bank account/IFSC combination is already registered against another CP
async function checkBankDetailsExists(accountNumber, ifscCode) {
  const { data, error } = await supabase
    .from("CP")
    .select("cpId, bankAccountNumber, bankIFSCCode")
    .eq("bankAccountNumber", accountNumber)
    .eq("bankIFSCCode", ifscCode);
  if (data) return data;
  else throw error;
}
async function checkBillingNameExists(billingName) {
  const { data, error } = await supabase
    .from("CP")
    .select("billingName")
    .match({ billingName: billingName });
  if (data) return data;
  else throw error;
}
async function checkBillingNameExistsInFos(billingName) {
  const { data, error } = await supabase
    .from("FOS")
    .select("name")
    .match({ name: billingName });
  if (data) return data;
  else throw error;
}
async function signOut() {
  return await supabase.auth.signOut();
}
function handleErrors(error, page, data) {
  console.log(page, ":", error);
  if (
    error?.message?.includes("FetchError: Failed to fetch") ||
    error?.message?.includes("Network Error")
  ) {
    Network.getStatus().then((resp) => {
      if (resp.connected) {
        offlineToast();
      } else {
        errorTost("Something went wrong!");
      }
    });
  } else {
    if (
      error?.message?.includes(
        'duplicate key value violates unique constraint "CP_billingName_key"'
      )
    ) {
      errorTost(`CP with Billing Name ${data} already exists`);
    } else if (error?.message?.includes("User already registered")) {
      errorTost("Contact Person email already exists");
    } else if (error?.message?.includes("BlacklistNumbers_number_key")) {
      errorTost("Number is blacklisted");
    } else if (
      error?.message?.includes(
        "You must provide either an email, phone number, a third-party provider or OpenID Connect."
      )
    ) {
      errorTost("Invalid Credentials");
    } else {
      errorTost(error.message);
    }
  }
}
async function getLatestCPData(cpId) {
  const { data, error } = await supabase
    .from("CpContactPerson")
    .select("*,cpId(*)")
    .eq("cpId", cpId)
    .single();
  if (data) return data;
  else throw error;
}
// Used by the pre-invoice CP verification step: marks the CP profile as
// rejected so invoice raising is blocked until the CP resubmits and is
// re-approved (mirrors FOSList.updateStatus's reject pattern for FOS).
async function rejectCpProfileForInvoice(cpId, reason) {
  const { data, error } = await supabase
    .from("CP")
    .update({
      approvalStatus: "rejected",
      rejectionReason: reason,
      last_updated_at: Date.now(),
    })
    .eq("cpId", cpId);
  if (error) throw error;
  return data;
}
// PAN/GST/RERA numbers live in KycDocuments (docType: "PanCard"/"GST"/"Rera"),
// not as columns on CP — used by the pre-invoice CP verification modal.
async function getLatestCpKycDetails(cpId) {
  const { data, error } = await supabase
    .from("KycDocuments")
    .select("docType,docNumber,last_updated_at")
    .eq("cpId", cpId)
    .order("last_updated_at", { ascending: false });
  if (error) throw error;
  const kyc = { panNumber: "", gstNumber: "", reraNumber: "" };
  (data || []).forEach((doc) => {
    if (doc.docType === "PanCard" && !kyc.panNumber) kyc.panNumber = doc.docNumber;
    else if (doc.docType === "GST" && !kyc.gstNumber) kyc.gstNumber = doc.docNumber;
    else if (doc.docType === "Rera" && !kyc.reraNumber) kyc.reraNumber = doc.docNumber;
  });
  return kyc;
}
async function getLatestFOSData(fosId, cpId) {
  const { data, error } = await supabase
    .from("FOS")
    .select("*,cpId(*)")
    .eq("fosId", fosId)
    .eq("cpId", cpId)
    .single();
  if (data) return data;
  else throw error;
}
async function insertLoginLogs(obj) {
  const { data, error } = await supabase.from("LoginLogs").insert(obj);
  if (data) return data;
  else throw error;
}
// **for dev
async function LoginLogs() {
  const { data, error } = await supabase.from("LoginLogs").select("*");
  if (data) return data;
  else throw error;
}
async function authSignUp(postData) {
  return await supabase.auth.signUp(postData);
}

//* Users table
async function insertUser(postBody) {
  return await insertQuery("Users", postBody).select("*").maybeSingle();
}
function insertQuery(tableName, postData) {
  let _postBody = { ...postData };
  _postBody.last_updated_at = Date.now();

  return supabase.from(tableName).insert(_postBody);
}
async function resetPassword(access_token, newPassword) {
  const { data, error } = await supabase.auth.api.updateUser(access_token, {
    password: newPassword,
  });
  if (data) return data;
  else throw error;
}
async function sendResetPasswordMail(email) {
  const { data, error } = await supabase.auth.api.resetPasswordForEmail(email, {
    redirectTo: process.env.REACT_APP_CP_RESET_PASSWORD,
  });
  if (data) return data;
  else throw error;
}
async function getCPDetails(email) {
  const { data, error } = await supabase
    .from("CpContactPerson")
    .select("*,cpId(*)")
    .eq("email", email);
  if (data) return data;
  else throw error;
}
async function getFosDetails(email) {
  const { data, error } = await supabase
    .from("FOS")
    .select("*")
    .eq("email", email);
  if (data) return data;
  else throw error;
}
//* Update Auth
async function authUpDateSignUp(postData) {
  return await supabase.auth.api.updateUser(
    JSON.parse(localStorage.getItem("supabase.auth.token")).currentSession
      .access_token,
    postData
  );
}

// async function checkPanNumberExistsUpdateCp(panNumber) {
//   const { data, error } = await supabase
//     .from("KycDocuments")
//     .select("cpId")
//     .eq("docType", "PanCard")
//     .eq("docNumber", panNumber);
//   return data || [];
// }



export {
  loginWithEmailPass,
  signOut,
  signUpCP,
  addKYCDoc,
  signUpFos,
  getCpBillingName,
  getCpId,
  addKYCDocFos,
  uploadFileToDb,
  checkCPIsAprroved,
  checkFOSIsAprroved,
  checkIsEmailExist,
  getSalesPerson,
  getCpSourceName,
  getCpSources,
  handleErrors,
  checkCPExists,
  checkFOSExists,
  getCPUId,
  getFOSId,
  checkPanNumberExists,
  checkReraNumberExists,
  checkGSTNumberExists,
  checkBankDetailsExists,
  checkBillingNameExists,
  checkBillingNameExistsInFos,
  checkForUniqueDocs,
  getLatestCPData,
  rejectCpProfileForInvoice,
  getLatestCpKycDetails,
  getLatestFOSData,
  insertLoginLogs,
  LoginLogs,
  updateRecommentdationToFoSTable,
  updatePasswordFlag,
  authSignUp,
  insertUser,
  resetPassword,
  checkIsEmailExistFP,
  sendResetPasswordMail,
  getCPDetails,
  getFosDetails,
  signUpStaticCP,
  authUpDateSignUp,
  checkPhoneExistsApi
// checkPanNumberExistsUpdateCp,
};